import * as React from "react";
import { createGlobalStyle } from "styled-components";
import { cn } from "lib/utils";
import "./styles.css";

export function AdoptWrapper({ className, ...props }) {
  return (
    <div className={cn("ls-adopt-wrapper", className)} {...props} />
  );
}

export const LiveWebsiteOverrides = createGlobalStyle`
  body .ls-app-wrapper .ui.button.primary,
  body .ls-app-wrapper .ui.primary.button,
  body .ls-app-wrapper .ui.primary.buttons .button {
    background: var(--primary-500);
    background-color: var(--primary-500);
  }

  body .ls-app-wrapper .ui.button.primary:hover,
  body .ls-app-wrapper .ui.button.primary:focus,
  body .ls-app-wrapper .ui.primary.button:hover,
  body .ls-app-wrapper .ui.primary.button:focus,
  body .ls-app-wrapper .ui.primary.buttons .button:hover,
  body .ls-app-wrapper .ui.primary.buttons .button:focus {
    background: var(--primary-700);
    background-color: var(--primary-700);
  }

  body .ls-app-wrapper .ui.button.secondary,
  body .ls-app-wrapper .ui.secondary.button,
  body .ls-app-wrapper .ui.secondary.buttons .button {
    background: var(--secondary-500);
    background-color: var(--secondary-500);
  }

  body .ls-app-wrapper .ui.button.secondary:hover,
  body .ls-app-wrapper .ui.button.secondary:focus,
  body .ls-app-wrapper .ui.secondary.button:hover,
  body .ls-app-wrapper .ui.secondary.button:focus,
  body .ls-app-wrapper .ui.secondary.buttons .button:hover,
  body .ls-app-wrapper .ui.secondary.buttons .button:focus {
    background: var(--secondary-700);
    background-color: var(--secondary-700);
  }

  body .ls-app-wrapper .ui.button.positive,
  body .ls-app-wrapper .ui.positive.button,
  body .ls-app-wrapper .ui.positive.buttons .button {
    background: var(--green-500);
    background-color: var(--green-500);
  }

  body .ls-app-wrapper .ui.button.positive:hover,
  body .ls-app-wrapper .ui.button.positive:focus,
  body .ls-app-wrapper .ui.positive.button:hover,
  body .ls-app-wrapper .ui.positive.button:focus,
  body .ls-app-wrapper .ui.positive.buttons .button:hover,
  body .ls-app-wrapper .ui.positive.buttons .button:focus {
    background: var(--green-700);
    background-color: var(--green-700);
  }
`;
